export default __webpack_public_path__ + "static/media/quizzes.d4012ce0.svg";